import React from 'react';
import { getAuthorizedUsers, updateUserRole } from 'src/store/slices/authorizationSlice';
import RoleAssignmentPanel from 'src/components/RoleAssignmentPanel';
import { isSessionUser, refreshUserRoles } from 'src/utils/roleSync';

const BASE_COLUMNS = [
  { field: 'ADSOYAD', headerName: 'Ad Soyad', flex: 1, minWidth: 180 },
  { field: 'SICILNO', headerName: 'Sicil No', width: 130 }
];
const SEARCH_FIELDS = ['ADSOYAD', 'SICILNO'];

function UserRoleAutho() {
  return (
    <RoleAssignmentPanel
      title="Kullanıcı Rol Yetkilendirme"
      unitLabel="kullanıcı"
      loadAction={getAuthorizedUsers}
      updateAction={updateUserRole}
      buildPayload={(row, roles) => ({ UserRoles: roles, UserId: row.ID })}
      getRowId={(row) => row.ID}
      baseColumns={BASE_COLUMNS}
      searchFields={SEARCH_FIELDS}
      searchPlaceholder="Ad soyad veya sicil no ara"
      getDialogInfo={(row) => ({ title: row.ADSOYAD, subtitle: `Sicil No: ${row.SICILNO}` })}
      // Kullanıcı kendi rolünü değiştirdiyse menü F5 gerekmeden güncellensin
      onSaved={(row) => { if (isSessionUser(row.SICILNO)) refreshUserRoles(); }}
    />
  );
}

export default UserRoleAutho;
